import _regeneratorRuntime from "/home/ubuntu/version/purple11/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import { createRef, createElement, Component, Fragment } from 'react';
import { useUniqueId } from '../uniqueId.js';
import { shape, string, oneOfType, number, bool, object, arrayOf, func, array, element } from 'prop-types';
import _get from 'lodash/get';
import { e as _inheritsLoose, f as _defineProperty, g as _assertThisInitialized, h as _asyncToGenerator, a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import Set from '../Set/index.js';
import _omit from 'lodash/omit';
import ConditionalWrap from 'conditional-wrap';
import { formikField, reduxFormField } from '../adaptors/fields.js';
import { a as FieldWrapper, b as fieldWrapperPropTypes, c as fieldWrapperDefaultProps } from '../chunk-1195bf9a.js';
import Group from '../Group/index.js';
import Popover from '../Popover/index.js';
import { menuItemPropTypes } from '../Menu/MenuItem.js';
import { menuPopoverPropTypes } from '../Menu/MenuPopover.js';
import _debounce from 'lodash/debounce';
import { Loads } from 'react-loads-next';
import _SelectMenu, { SelectMenuPopover, SelectMenuTopSection, SelectMenuTag, SelectMenuGroup, SelectMenuItem, SelectMenuStaticItem, SelectMenuLoadingItemSpinner, SelectMenuBottomSection, SelectMenuActionButton, SelectMenuButton, SelectMenuLoadingSpinner } from './styled.js';
import SelectIcon from './SelectIcon.js';
import SelectMenuSearchInput, { selectMenuSearchInputPropTypes } from './SelectMenuSearchInput.js';
var selectMenuItemObjectPropType = shape({
  icon: menuItemPropTypes['icon'],
  isActive: menuItemPropTypes['isActive'],
  isDisabled: menuItemPropTypes['isDisabled'],
  label: string,
  value: oneOfType([string, number, bool, object])
});
var selectMenuItemPropType = oneOfType([string, selectMenuItemObjectPropType]);
var selectMenuItemsPropType = arrayOf(selectMenuItemPropType);

var getSelectedOptionsFromValue = function getSelectedOptionsFromValue(value) {
  if (!value) return {};

  if (typeof value === 'string') {
    var _ref;

    return _ref = {}, _ref[value] = value, _ref;
  }

  if (Array.isArray(value)) {
    return value.reduce(function (currentSelectedOptions, defaultOption) {
      var _objectSpread2;

      var key = _get(defaultOption, 'key', defaultOption);

      return _objectSpread({}, currentSelectedOptions, (_objectSpread2 = {}, _objectSpread2[key] = defaultOption, _objectSpread2));
    }, {});
  }

  if (typeof value === 'object') {
    var _ref2;

    var _key = _get(value, 'key', value);

    return _ref2 = {}, _ref2[_key] = value, _ref2;
  }

  return {};
};

var getDefaultSelectedOptionsFromProps = function getDefaultSelectedOptionsFromProps(props) {
  var defaultKey = props.defaultKey,
      defaultKeys = props.defaultKeys,
      defaultOption = props.defaultOption,
      defaultOptions = props.defaultOptions,
      options = props.options,
      value = props.value;

  if (value) {
    return getSelectedOptionsFromValue(value);
  }

  if (defaultOption) {
    var _ref3;

    var _key2 = _get(defaultOption, 'key', defaultOption);

    return _ref3 = {}, _ref3[_key2] = defaultOption, _ref3;
  }

  if (defaultOptions) {
    return defaultOptions.reduce(function (currentSelectedOptions, defaultOption) {
      var _objectSpread3;

      var key = _get(defaultOption, 'key', defaultOption);

      return _objectSpread({}, currentSelectedOptions, (_objectSpread3 = {}, _objectSpread3[key] = defaultOption, _objectSpread3));
    }, {});
  }

  if (options) {
    return options.reduce(function (currentSelectedOptions, option) {
      var key = _get(option, 'key', option);

      if (key === defaultKey || defaultKeys && defaultKeys.some(function (defaultKey) {
        return defaultKey === key;
      }) || _get(option, 'isDefault')) {
        var _objectSpread4;

        return _objectSpread({}, currentSelectedOptions, (_objectSpread4 = {}, _objectSpread4[key] = option, _objectSpread4));
      }

      return currentSelectedOptions;
    }, {});
  }

  return {};
};

var getAttribute = function getAttribute(options, attr) {
  return _get(Object.values(options), "[0]." + attr) || _get(Object.values(options), '[0]');
};

var getAttributes = function getAttributes(options, attr) {
  return Object.values(options).map(function (option) {
    return _get(option, attr, option);
  });
};

var getButtonValue = function getButtonValue(options) {
  var labels = getAttributes(options, 'label');

  if (labels.length === 1) {
    return labels[0];
  }

  return labels.length + " selected";
};

var optionsFilter = function optionsFilter(_ref4) {
  var options = _ref4.options,
      searchText = _ref4.searchText;
  return options.filter(function (option) {
    return _get(option, 'label', option).toLowerCase().includes(searchText.toLowerCase());
  });
};

var bottomActionsRenderer = function bottomActionsRenderer(_ref5) {
  var isDropdown = _ref5.isDropdown,
      isMultiSelect = _ref5.isMultiSelect,
      onClear = _ref5.onClear,
      popover = _ref5.popover,
      selectedOptions = _ref5.selectedOptions;
  return createElement(Fragment, null, isMultiSelect && Object.keys(selectedOptions).length > 0 ? createElement(SelectMenuActionButton, {
    kind: "ghost",
    onClick: onClear
  }, "Clear") : createElement("div", null), isDropdown && createElement(SelectMenuActionButton, _extends({
    use: Popover.Hide,
    kind: "ghost"
  }, popover), "Close"));
};

var emptyRenderer = function emptyRenderer(_ref6) {
  var emptyText = _ref6.emptyText;
  return createElement(SelectMenuStaticItem, null, emptyText);
};

var errorRenderer = function errorRenderer() {
  return createElement(SelectMenuStaticItem, null, "An error occurred. Please try again.");
};

var optionRenderer = function optionRenderer(option) {
  return _get(option, 'label', option);
};

var triggerRenderer = function triggerRenderer(_ref7) {
  var isLoading = _ref7.isLoading,
      props = _ref7.props;
  return (
    /*
    // @ts-ignore */
    createElement(SelectMenuButton, props, props.children, isLoading ? createElement(SelectMenuLoadingSpinner, {
      color: "text",
      size: "1rem"
    }) : createElement(SelectIcon, null))
  );
}; // @ts-ignore


var valueRenderer = function valueRenderer(value, values, selectedOptions) {
  return getButtonValue(selectedOptions);
};

var selectMenuPropTypes = {
  defaultKey: string,
  defaultKeys: arrayOf(string),
  defaultOption: selectMenuItemPropType,
  defaultOptions: selectMenuItemsPropType,
  disabled: bool,
  emptyText: string,
  filterOptions: func,
  isDropdown: bool,
  isFullWidth: bool,
  isLoading: bool,
  isMultiSelect: bool,
  isPaginated: bool,
  isRadio: bool,
  isSearchable: bool,
  loadQuery: object,
  loadOptions: func,
  onChange: func,
  options: selectMenuItemsPropType,
  placeholder: string,
  popoverProps: shape(_omit(menuPopoverPropTypes, 'children', 'content')),
  renderBottomActions: func,
  renderEmpty: func,
  renderError: func,
  renderOption: func,
  renderTrigger: func,
  renderValue: func,
  searchInputProps: shape(selectMenuSearchInputPropTypes),
  useTags: bool,
  value: oneOfType([string, object, array])
};
var selectMenuDefaultProps = {
  defaultKey: undefined,
  defaultKeys: undefined,
  defaultOption: undefined,
  defaultOptions: undefined,
  disabled: false,
  emptyText: 'No results found',
  filterOptions: optionsFilter,
  isDropdown: false,
  isFullWidth: false,
  isLoading: false,
  isMultiSelect: false,
  isPaginated: true,
  isRadio: false,
  isSearchable: false,
  loadQuery: undefined,
  loadOptions: undefined,
  onChange: undefined,
  options: [],
  placeholder: 'Select...',
  popoverProps: {},
  renderBottomActions: bottomActionsRenderer,
  renderEmpty: emptyRenderer,
  renderError: errorRenderer,
  renderOption: optionRenderer,
  renderTrigger: triggerRenderer,
  renderValue: valueRenderer,
  searchInputProps: {},
  useTags: false,
  value: undefined
};

var SelectMenu = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SelectMenu, _React$Component);

  function SelectMenu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key3 = 0; _key3 < _len; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "optionsGroup", createRef());

    _defineProperty(_assertThisInitialized(_this), "state", {
      blockLoad: false,
      contextKey: _this.props.loadQuery ? Object.values(_this.props.loadQuery).join('.') : undefined,
      options: _this.props.options || [],
      page: 1,
      selectedOptions: getDefaultSelectedOptionsFromProps(_this.props),
      searchText: ''
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          loadQuery = _this$props.loadQuery,
          options = _this$props.options,
          value = _this$props.value;
      var prevLoadQuery = prevProps.loadQuery,
          prevOptions = prevProps.options,
          prevValue = prevProps.value;

      if (value !== prevValue) {
        _this.setState({
          selectedOptions: getSelectedOptionsFromValue(value)
        });
      }

      if (options && _get(options, 'length') !== _get(prevOptions, 'length')) {
        _this.setState({
          selectedOptions: getDefaultSelectedOptionsFromProps(_this.props)
        });

        _this.filterOptions();
      }

      if (loadQuery && loadQuery !== prevLoadQuery) {
        _this.setState({
          contextKey: Object.values(loadQuery).join('.'),
          page: 1,
          searchText: ''
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "loadOptions", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props2, loadQuery, loadOptions, initialOptions, _this$state, blockLoad, currentOptions, page, searchText, _ref9, options, newOptions;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props2 = _this.props, loadQuery = _this$props2.loadQuery, loadOptions = _this$props2.loadOptions, initialOptions = _this$props2.options;
              _this$state = _this.state, blockLoad = _this$state.blockLoad, currentOptions = _this$state.options, page = _this$state.page, searchText = _this$state.searchText;

              if (loadOptions) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return", null);

            case 4:
              if (!blockLoad) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return", null);

            case 6:
              _context.next = 8;
              return loadOptions({
                data: loadQuery,
                page: page,
                searchText: searchText
              });

            case 8:
              _ref9 = _context.sent;
              options = _ref9.options;

              if (options.length === 0 && page > 1) {
                _this.setState({
                  blockLoad: true
                });
              }

              newOptions = [].concat(currentOptions, options);

              if (page === 1) {
                newOptions = [].concat(options);

                if (initialOptions) {
                  newOptions = [].concat(initialOptions, newOptions);
                }
              }

              _this.setState({
                options: newOptions
              });

              return _context.abrupt("return");

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "handleClearSelected", function () {
      var onChange = _this.props.onChange;
      onChange && onChange(null, null, null);

      _this.setState({
        selectedOptions: {}
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleClickOption", function (option) {
      return function () {
        var _this$props3 = _this.props,
            isMultiSelect = _this$props3.isMultiSelect,
            isRadio = _this$props3.isRadio,
            onChange = _this$props3.onChange;
        var selectedOptions = _this.state.selectedOptions;

        var key = _get(option, 'key', option); // @ts-ignore


        var isOptionSelected = Boolean(selectedOptions[key]);
        var newSelectedOptions = isMultiSelect ? selectedOptions : {};

        if (isOptionSelected && !isRadio) {
          // @ts-ignore
          delete newSelectedOptions[key];
        } else {
          // @ts-ignore
          newSelectedOptions[key] = option;
        }

        _this.setState({
          selectedOptions: newSelectedOptions
        });

        var newValues = Object.values(newSelectedOptions);

        if (newValues.length === 0) {
          newValues = null;
        } else if (!isMultiSelect) {
          newValues = newValues[0];
        }

        var value = _get(option, 'value', option);

        onChange && onChange(value, option, newValues);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleRemoveOption", function (option) {
      return function () {
        var _this$props4 = _this.props,
            isMultiSelect = _this$props4.isMultiSelect,
            onChange = _this$props4.onChange;
        var selectedOptions = _this.state.selectedOptions;

        var newSelectedOptions = _objectSpread({}, selectedOptions); // @ts-ignore


        delete newSelectedOptions[_get(option, 'key', option)];

        _this.setState({
          selectedOptions: newSelectedOptions
        });

        var newValues = Object.values(newSelectedOptions);

        if (newValues.length === 0) {
          newValues = null;
        } else if (!isMultiSelect) {
          newValues = newValues[0];
        }

        var value = _get(option, 'value', option);

        onChange && onChange(value, option, newValues);
      };
    });

    _defineProperty(_assertThisInitialized(_this), "handleScrollOptions", function (_ref10) {
      var event = _ref10.event,
          isLoading = _ref10.isLoading,
          load = _ref10.load;
      var isPaginated = _this.props.isPaginated;
      var page = _this.state.page;
      var target = event.currentTarget;

      if (isPaginated && !isLoading && target.scrollHeight > target.offsetHeight && target.scrollHeight - target.offsetHeight - target.scrollTop <= 200) {
        var nextPage = page + 1;

        _this.setState({
          page: nextPage
        }, load);
      }

      return;
    });

    _defineProperty(_assertThisInitialized(_this), "handleSearch", _debounce(function (_ref11) {
      var event = _ref11.event,
          load = _ref11.load;
      var searchText = event.target.value;
      var loadOptions = _this.props.loadOptions;

      _this.setState({
        blockLoad: false,
        searchText: searchText,
        page: 1
      }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!loadOptions) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 3;
                return load();

              case 3:
                _context2.next = 6;
                break;

              case 5:
                _this.filterOptions();

              case 6:
                _this.optionsGroup && _this.optionsGroup.current && _this.optionsGroup.current.scrollTo({
                  top: 0
                });

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      })));
    }, 500));

    _defineProperty(_assertThisInitialized(_this), "filterOptions", function () {
      var _this$props5 = _this.props,
          filterOptions = _this$props5.filterOptions,
          options = _this$props5.options;
      var searchText = _this.state.searchText;
      if (!options) return;
      var filteredOptions = searchText.trim() === '' ? options : filterOptions({
        options: options,
        searchText: searchText
      });

      _this.setState({
        options: filteredOptions
      });
    });

    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props6 = _this.props,
          isDropdown = _this$props6.isDropdown,
          isLoading = _this$props6.isLoading,
          popoverProps = _this$props6.popoverProps,
          placeholder = _this$props6.placeholder,
          renderTrigger = _this$props6.renderTrigger,
          renderValue = _this$props6.renderValue,
          props = _objectWithoutPropertiesLoose(_this$props6, ["isDropdown", "isLoading", "popoverProps", "placeholder", "renderTrigger", "renderValue"]);

      var _this$state2 = _this.state,
          contextKey = _this$state2.contextKey,
          selectedOptions = _this$state2.selectedOptions;
      return (// @ts-ignore
        createElement(Loads, {
          context: contextKey,
          fn: _this.loadOptions,
          defer: !_this.loadOptions
        }, function (record) {
          return isDropdown ? createElement(SelectMenuPopover, _extends({
            content: _this.renderMenu(record)
          }, popoverProps), renderTrigger && renderTrigger({
            isLoading: isLoading,
            placeholder: placeholder,
            props: _objectSpread({}, props, {
              children: Object.keys(selectedOptions).length > 0 && renderValue ? renderValue(getAttribute(selectedOptions, 'value'), getAttributes(selectedOptions, 'value'), selectedOptions) : placeholder
            }),
            selectedOptions: selectedOptions,
            renderValue: renderValue
          })) : _this.renderMenu(record)();
        })
      );
    });

    _defineProperty(_assertThisInitialized(_this), "renderMenu", function (_ref13) {
      var load = _ref13.load,
          error = _ref13.error,
          isPending = _ref13.isPending,
          isResolved = _ref13.isResolved,
          isRejected = _ref13.isRejected;
      return function (popover) {
        var _this$props7 = _this.props,
            renderBottomActions = _this$props7.renderBottomActions,
            isDropdown = _this$props7.isDropdown,
            isMultiSelect = _this$props7.isMultiSelect,
            isSearchable = _this$props7.isSearchable,
            loadOptions = _this$props7.loadOptions,
            renderOption = _this$props7.renderOption,
            searchInputProps = _this$props7.searchInputProps,
            useTags = _this$props7.useTags,
            props = _objectWithoutPropertiesLoose(_this$props7, ["renderBottomActions", "isDropdown", "isMultiSelect", "isSearchable", "loadOptions", "renderOption", "searchInputProps", "useTags"]);

        var selectedOptions = _this.state.selectedOptions;
        var selectedOptionsValues = Object.values(selectedOptions);
        return createElement(_SelectMenu, _extends({
          setInitialFocus: !isSearchable
        }, isDropdown ? {} : props), isSearchable && createElement(SelectMenuSearchInput, _extends({
          isDropdownActive: popover && popover.isVisible,
          isLoading: isPending,
          onChange: function onChange(event) {
            event.persist();

            _this.handleSearch({
              event: event,
              load: load
            });
          }
        }, searchInputProps)), useTags && selectedOptionsValues.length > 0 && _this.renderTopSection({
          selectedOptionsValues: selectedOptionsValues
        }), _this.renderOptions({
          error: error,
          isLoading: isPending,
          isResolved: isResolved,
          isRejected: isRejected,
          load: load
        }), (isMultiSelect || isDropdown) && _this.renderBottomSection({
          popover: popover,
          selectedOptionsValues: selectedOptionsValues
        }));
      };
    });

    _defineProperty(_assertThisInitialized(_this), "renderTopSection", function (_ref14) {
      var selectedOptionsValues = _ref14.selectedOptionsValues;
      return createElement(SelectMenuTopSection, null, createElement(Set, {
        spacing: "minor-1"
      }, selectedOptionsValues.map(function (option) {
        return createElement(SelectMenuTag, {
          key: _get(option, 'key', option),
          onRemove: _this.handleRemoveOption(option),
          palette: "primary"
        }, _get(option, 'label', option));
      })));
    });

    _defineProperty(_assertThisInitialized(_this), "renderOptions", function (_ref15) {
      var error = _ref15.error,
          isLoading = _ref15.isLoading,
          isResolved = _ref15.isResolved,
          isRejected = _ref15.isRejected,
          load = _ref15.load;
      var _this$props8 = _this.props,
          emptyText = _this$props8.emptyText,
          isDropdown = _this$props8.isDropdown,
          isMultiSelect = _this$props8.isMultiSelect,
          renderEmpty = _this$props8.renderEmpty,
          renderError = _this$props8.renderError,
          renderOption = _this$props8.renderOption,
          useTags = _this$props8.useTags;
      var _this$state3 = _this.state,
          options = _this$state3.options,
          selectedOptions = _this$state3.selectedOptions;
      return (// @ts-ignore
        createElement(SelectMenuGroup // @ts-ignore
        , {
          elementRef: _this.optionsGroup,
          isDropdown: isDropdown,
          isMultiSelect: isMultiSelect,
          onScroll: function onScroll(event) {
            return _this.handleScrollOptions({
              event: event,
              isLoading: isLoading,
              load: load
            });
          }
        }, options.map(function (option) {
          // @ts-ignore
          var isSelected = Boolean(selectedOptions[_get(option, 'key', option)]);
          if (useTags && isSelected) return null;
          return createElement(SelectMenuItem, {
            key: _get(option, 'key', option),
            hideOnClick: !isMultiSelect,
            icon: _get(option, 'icon'),
            isActive: isSelected || _get(option, 'isActive'),
            isDisabled: _get(option, 'isDisabled'),
            onClick: _this.handleClickOption(option)
          }, renderOption && renderOption(option));
        }), isLoading && createElement(SelectMenuStaticItem, null, createElement(SelectMenuLoadingItemSpinner, {
          color: "text",
          size: "1rem"
        })), isResolved && options.length === 0 && renderEmpty && renderEmpty({
          emptyText: emptyText
        }), isRejected && error && renderError && renderError({
          error: error
        }))
      );
    });

    _defineProperty(_assertThisInitialized(_this), "renderBottomSection", function (_ref16) {
      var popover = _ref16.popover,
          selectedOptionsValues = _ref16.selectedOptionsValues;
      var _this$props9 = _this.props,
          isDropdown = _this$props9.isDropdown,
          isMultiSelect = _this$props9.isMultiSelect,
          renderBottomActions = _this$props9.renderBottomActions;
      return createElement(SelectMenuBottomSection, null, renderBottomActions && renderBottomActions({
        isDropdown: isDropdown,
        isMultiSelect: isMultiSelect,
        onClear: _this.handleClearSelected,
        popover: popover,
        selectedOptions: selectedOptionsValues
      }));
    });

    return _this;
  }

  return SelectMenu;
}(Component); // @ts-ignore


_defineProperty(SelectMenu, "ActionButton", SelectMenuActionButton);

_defineProperty(SelectMenu, "BottomSection", SelectMenuBottomSection);

_defineProperty(SelectMenu, "Button", SelectMenuButton);

_defineProperty(SelectMenu, "LoadingSpinner", SelectMenuLoadingSpinner);

_defineProperty(SelectMenu, "LoadingItemSpinner", SelectMenuLoadingItemSpinner);

_defineProperty(SelectMenu, "Group", SelectMenuGroup);

_defineProperty(SelectMenu, "Item", SelectMenuItem);

_defineProperty(SelectMenu, "StaticItem", SelectMenuStaticItem);

_defineProperty(SelectMenu, "Popover", SelectMenuPopover);

_defineProperty(SelectMenu, "Tag", SelectMenuTag);

_defineProperty(SelectMenu, "TopSection", SelectMenuTopSection);

_defineProperty(SelectMenu, "propTypes", selectMenuPropTypes);

_defineProperty(SelectMenu, "defaultProps", selectMenuDefaultProps);

SelectMenu.Formik = formikField(SelectMenu, {
  isSelectMenu: true
}); // @ts-ignore

SelectMenu.ReduxForm = reduxFormField(SelectMenu, {
  isSelectMenu: true
});

var SelectMenuField = function SelectMenuField(_ref) {
  var _a11yId = _ref.a11yId,
      addonBefore = _ref.addonBefore,
      addonAfter = _ref.addonAfter,
      className = _ref.className,
      defaultKey = _ref.defaultKey,
      defaultKeys = _ref.defaultKeys,
      defaultOption = _ref.defaultOption,
      defaultOptions = _ref.defaultOptions,
      description = _ref.description,
      disabled = _ref.disabled,
      emptyText = _ref.emptyText,
      filterOptions = _ref.filterOptions,
      hint = _ref.hint,
      isDropdown = _ref.isDropdown,
      isLoading = _ref.isLoading,
      isMultiSelect = _ref.isMultiSelect,
      isOptional = _ref.isOptional,
      isPaginated = _ref.isPaginated,
      isRequired = _ref.isRequired,
      isSearchable = _ref.isSearchable,
      isVertical = _ref.isVertical,
      label = _ref.label,
      loadQuery = _ref.loadQuery,
      loadOptions = _ref.loadOptions,
      onChange = _ref.onChange,
      options = _ref.options,
      placeholder = _ref.placeholder,
      popoverProps = _ref.popoverProps,
      renderBottomActions = _ref.renderBottomActions,
      renderEmpty = _ref.renderEmpty,
      renderError = _ref.renderError,
      renderOption = _ref.renderOption,
      renderTrigger = _ref.renderTrigger,
      renderValue = _ref.renderValue,
      selectMenuProps = _ref.selectMenuProps,
      searchInputProps = _ref.searchInputProps,
      state = _ref.state,
      validationText = _ref.validationText,
      value = _ref.value,
      useTags = _ref.useTags,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yId", "addonBefore", "addonAfter", "className", "defaultKey", "defaultKeys", "defaultOption", "defaultOptions", "description", "disabled", "emptyText", "filterOptions", "hint", "isDropdown", "isLoading", "isMultiSelect", "isOptional", "isPaginated", "isRequired", "isSearchable", "isVertical", "label", "loadQuery", "loadOptions", "onChange", "options", "placeholder", "popoverProps", "renderBottomActions", "renderEmpty", "renderError", "renderOption", "renderTrigger", "renderValue", "selectMenuProps", "searchInputProps", "state", "validationText", "value", "useTags"]);

  var uniqueId = useUniqueId('SelectMenuField');
  var a11yId = _a11yId || uniqueId;
  return createElement(FieldWrapper, _extends({
    a11yId: a11yId,
    description: description,
    hint: hint,
    isOptional: isOptional,
    isRequired: isRequired,
    label: label,
    state: state,
    validationText: validationText
  }, props), function (_ref2) {
    var elementProps = _ref2.elementProps;
    return createElement(ConditionalWrap, {
      condition: addonBefore || addonAfter,
      wrap: function wrap(children) {
        return createElement(Group, {
          isVertical: isVertical
        }, children);
      }
    }, addonBefore, createElement(SelectMenu, _extends({
      id: a11yId,
      className: className,
      defaultKey: defaultKey,
      defaultKeys: defaultKeys,
      defaultOption: defaultOption,
      defaultOptions: defaultOptions,
      disabled: disabled,
      emptyText: emptyText,
      filterOptions: filterOptions,
      isDropdown: isDropdown,
      isLoading: isLoading,
      isMultiSelect: isMultiSelect,
      isPaginated: isPaginated,
      isRequired: isRequired,
      isSearchable: isSearchable,
      loadQuery: loadQuery,
      loadOptions: loadOptions // @ts-ignore
      ,
      onChange: onChange,
      options: options,
      placeholder: placeholder,
      popoverProps: popoverProps,
      renderBottomActions: renderBottomActions,
      renderEmpty: renderEmpty,
      renderError: renderError,
      renderOption: renderOption,
      renderTrigger: renderTrigger,
      renderValue: renderValue,
      searchInputProps: searchInputProps,
      state: state // @ts-ignore
      ,
      value: value,
      useTags: useTags
    }, elementProps, selectMenuProps)), addonAfter);
  });
};

SelectMenuField.Formik = formikField(SelectMenuField, {
  hasFieldWrapper: true,
  isSelectMenu: true
});
SelectMenuField.ReduxForm = reduxFormField(SelectMenuField, {
  hasFieldWrapper: true,
  isSelectMenu: true
});

var selectMenuFieldPropTypes = _objectSpread({
  addonBefore: element,
  addonAfter: element,
  isVertical: bool,
  selectMenuProps: shape(selectMenuPropTypes)
}, _omit(fieldWrapperPropTypes, 'children'), selectMenuPropTypes);

SelectMenuField.propTypes = selectMenuFieldPropTypes;

var selectMenuFieldDefaultProps = _objectSpread({}, fieldWrapperDefaultProps, selectMenuDefaultProps, {
  addonBefore: undefined,
  addonAfter: undefined,
  a11yId: undefined,
  isVertical: false,
  selectMenuProps: {}
});

SelectMenuField.defaultProps = selectMenuFieldDefaultProps; // @ts-ignore

var C = SelectMenuField;
export { SelectMenu as a, SelectMenuField as b, selectMenuFieldPropTypes as c, selectMenuFieldDefaultProps as d, C as e, selectMenuPropTypes as f, selectMenuDefaultProps as g };